module.exports = "/images/ny-life1-9.jpg";